// 상담수단·상담목적 — 상담(member_consultation)과 잠재회원이 공유한다.
// 백엔드 ConsultMethod / ConsultPurpose enum 과 값·순서를 맞춘다.
export const CONSULT_METHOD_LABELS = {
  VISIT: '방문',
  PHONE: '전화',
  MESSAGE: '문자',
  SNS: 'SNS',
  ETC: '기타',
};

export const CONSULT_PURPOSE_LABELS = {
  NEW_INQUIRY: '신규문의',
  RE_REGISTER: '재등록',
  PRODUCT_PURCHASE: '일반상품 구매',
  REFERRAL: '지인소개',
  LESSON_INQUIRY: '레슨문의',
  REFUND: '환불',
  TRANSFER: '양도',
  ETC: '기타',
};

// 상담 결과 — 상담을 잡은 시점은 예정이고, 상담이 끝나면 나머지 중 하나로 바꾼다.
// 종료시간이 지나도록 예정이면 백엔드 새벽 배치가 미확인으로 자동 전환한다.
// 신규등록(잠재→회원 전환 판매)·재등록(기존 회원 재구매)은 판매등록 시 백엔드가 자동으로도 반영한다.
// 고민 중·미등록도 판매등록되면 신규/재등록으로 바뀐다. 예약 스케줄 변경(상담 일정 변경)은 그대로 둔다.
export const CONSULT_RESULT_LABELS = {
  SCHEDULED: '예정',
  RESCHEDULED: '예약 스케줄 변경',
  UNCONFIRMED: '미확인',
  NO_SHOW: '미방문',
  VISITED: '방문',
  CONSIDERING: '고민 중',
  NOT_REGISTERED: '미등록',
  NEW_REGISTERED: '신규등록',
  RE_REGISTERED: '재등록',
};

// 결과 뱃지 색 (상세 모달·이력 뱃지 공용)
export const CONSULT_RESULT_COLORS = {
  SCHEDULED: '#1E4FA3',
  RESCHEDULED: '#0284C7',
  UNCONFIRMED: '#6B7280',
  NO_SHOW: '#C7362A',
  // 방문은 앰버. 청록이던 시절 신규등록(초록)과 한눈에 구분이 안 됐다.
  VISITED: '#B45309',
  CONSIDERING: '#A21CAF',
  NOT_REGISTERED: '#44403C',
  NEW_REGISTERED: '#1F7343',
  RE_REGISTERED: '#5B21B6',
};

export const CONSULT_METHOD_OPTIONS = Object.entries(CONSULT_METHOD_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const CONSULT_PURPOSE_OPTIONS = Object.entries(CONSULT_PURPOSE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const CONSULT_RESULT_OPTIONS = Object.entries(CONSULT_RESULT_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const getConsultMethodLabel = method => CONSULT_METHOD_LABELS[method] || method || '-';

export const getConsultResultLabel = result => CONSULT_RESULT_LABELS[result] || result || '-';

export const getConsultPurposeLabel = purpose => CONSULT_PURPOSE_LABELS[purpose] || purpose || '-';
